module.exports = "<p>\r\n  other-material works!\r\n</p>\r\n"